var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word_cloud mx-3 mt-4"},[_c('b-table',{attrs:{"fields":_vm.fields,"thead-class":"head-table-green","hover":"","items":_vm.top_search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }